export default {
	form_type: {
		text: 'Rövid válasz',
		paragraph: 'Bekezdés',
		checkbox: 'Jelölőnégyzet',
		radio: 'Feleletválasztó',
		select: 'Legördülő lista',
		linear_scale: 'Lineáris skála',
		radio_grid: 'Feleletválasztós rács',
		checkbox_grid: 'Jelölőnégyzet rács',
		date: 'Dátum',
		datetime: 'Dátum / Idő',
		time: 'Idő',
		interpretation: 'Leírás',
	},
};
